module.exports = __webpack_public_path__ + "components/flag/static/square/tt-79508f9c7934469f6c6eb5f58fb3803d.svg";